import { SLicenseContainer } from './SingingPortraitsHero.styled'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'

export const License = (props: { className?: string; isAbsolute?: boolean }) => {
  const { t } = useTranslation('memory')

  return (
    <SLicenseContainer className={props?.className} isAbsolute={props.isAbsolute}>
      <Text>{t('memory.singing.license_text')}</Text>
      <Icon name="LogoDid" />
    </SLicenseContainer>
  )
}
